import { exportGoodsCsv } from '@/api/goodsSetting'
import type { MallExportRequest } from '@/api/goodsSetting'
import { handleExportFile } from '@/common'

/** 沿用渠道导出和下载工具，避免把业务错误JSON保存成Excel。 */
export async function downloadMallExport(request: MallExportRequest) {
  const blob = await exportGoodsCsv(request)
  if (!(blob instanceof Blob)) throw Object.assign(new Error(blob?.msg || '导出失败，请重试'), { code: blob?.code })
  const signature = new Uint8Array(await blob.slice(0, 4).arrayBuffer())
  if (signature[0] !== 0x50 || signature[1] !== 0x4b) {
    let message = '导出失败，请重新确认商品范围'
    let code: string | undefined
    try {
      const result = JSON.parse(await blob.text())
      message = result.msg || message
      code = result.code
    } catch (error) {
      /* 非JSON错误同样不下载 */
    }
    throw Object.assign(new Error(message), { code })
  }
  handleExportFile(blob, '微信商城道具', 'xlsx')
}
